import { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import { ScheduledPickupItem } from '@/features/schedule-pickup/types';
import { parseError } from '@/features/common/helpers/errorParser';
import { GlobalResponseType } from '@/features/common/types';

const { axiosService } = useAxios();

export interface UrlQuery {
  offset?: number,
  limit?: number,
  orderBy?: string,
  orderByDesc?: boolean,
  search?: string | null,
  carriers?: string[],
  dateRange?: string[],
  showFutureDay?: boolean,
  showCancelled?: boolean,
}

export const getPickupHistoryItems = async ({
  offset = 0,
  limit = 30,
  orderBy = 'pickupRequestDate',
  orderByDesc = true,
  search = null,
  carriers = [],
  dateRange = [],
  showFutureDay = true,
  showCancelled = true,
}: UrlQuery = {}): Promise<ScheduledPickupItem[] | null> => {
  try {
    let queryString = `?Offset=${offset}&Limit=${limit}&OrderBy=${orderBy}&OrderByDescending=${orderByDesc}`;
    if (search) {
      queryString += `&search=${encodeURI(search)}`;
    }
    if (carriers.length) {
      carriers.forEach((carrier) => {
        queryString += `&carriers=${carrier}`;
      });
    }
    if (dateRange.length) {
      const [fromDate, toDate] = dateRange;
      if (fromDate) {
        queryString += `&fromDate=${fromDate}`;
      }
      if (toDate) {
        queryString += `&toDate=${toDate}`;
      }
    }

    queryString += `&showFutureDay=${showFutureDay}`;
    queryString += `&showCancelled=${showCancelled}`;

    const scheduledPickupsRes: AxiosResponse = await axiosService.get(
      `/pickups/scheduled${queryString}`,
    );
    return scheduledPickupsRes.data ?? [];
  } catch (err) {
    return null;
  }
};

export const cancelPickup = async (
  id: number | string,
): Promise<GlobalResponseType | null> => {
  try {
    await axiosService.delete(
      `/pickups/cancel/${id}`,
    );

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      isCarrierMessage: false,
    };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return parseError(err);
  }
};

export const getAScheduledPickup = async (
  id: number | string,
): Promise<ScheduledPickupItem | null> => {
  try {
    const response: AxiosResponse = await axiosService.get(
      `/pickups/scheduled/${id}`,
    );
    return response.data;
  } catch (err) {
    return null;
  }
};
